import { useState } from "react";
import { toast } from "sonner";
import { Upload, Eye, Trash2 } from "lucide-react";
import { api, BACKEND, errMsg } from "@/lib/api";
import { Loading, Table, Title, confirmRun, fmtDay, useData } from "@/ops/ui";

const TYPES = [["kimlik_karti", "Özel güvenlik kimlik kartı"], ["egitim", "Eğitim / sertifika"], ["saglik", "Sağlık raporu"], ["adli_sicil", "Adli sicil kaydı"], ["diger", "Diğer"]];
function state(d) {
  if (!d) return ["Süresiz", ""];
  const days = (new Date(d) - new Date()) / 864e5;
  if (days < 0) return ["Süresi dolmuş", "text-red-700"];
  if (days <= 60) return ["60 gün içinde doluyor", "text-orange-700"];
  return ["Geçerli", "text-emerald-700"];
}

function UploadForm({ emps, onDone }) {
  const [v, setV] = useState({ employee_id: "", doc_type: "kimlik_karti", title: "", expiry: "" });
  const [file, setFile] = useState(null);
  const submit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    Object.entries(v).forEach(([k, x]) => fd.append(k, x));
    fd.append("file", file);
    try {
      await api.post("/ops/admin/personnel-docs", fd);
      toast.success("Belge yüklendi");
      onDone();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });
  return (
    <form onSubmit={submit} className="mb-5 grid gap-2 rounded-lg border border-zinc-200 bg-white p-4 md:grid-cols-6" data-testid="doc-upload-form">
      <select required value={v.employee_id} onChange={set("employee_id")} className="field-input md:col-span-2" data-testid="doc-employee"><option value="">Personel seçin</option>{emps.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}</select>
      <select value={v.doc_type} onChange={set("doc_type")} className="field-input" data-testid="doc-type">{TYPES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
      <input value={v.title} onChange={set("title")} placeholder="Belge adı / no" className="field-input" data-testid="doc-title" />
      <input type="date" value={v.expiry} onChange={set("expiry")} className="field-input" title="Son geçerlilik" data-testid="doc-expiry" />
      <label className="btn-outline cursor-pointer justify-center !py-2"><Upload className="h-4 w-4" /> {file ? file.name.slice(0, 14) : "Dosya"}<input type="file" required accept=".pdf,.jpg,.jpeg,.png" className="sr-only" onChange={(e) => setFile(e.target.files[0])} data-testid="doc-file" /></label>
      <button className="btn-red justify-center !py-2 md:col-span-6" data-testid="doc-submit">Yükle</button>
    </form>
  );
}

export default function PersonnelDocs() {
  const [only, setOnly] = useState("");
  const [rows, reload] = useData("/ops/admin/personnel-docs", { expiring: only });
  const [emps] = useData("/ops/admin/employees");
  return (
    <div>
      <Title title="Personel Özlük Belgeleri" desc="Belgeler yalnızca yöneticilere açıktır; görüntüleme ve silme işlemleri kayda geçer. Kimlik kartı süreleri Personel sayfasında da izlenir." />
      {emps && <UploadForm emps={emps} onDone={reload} />}
      <label className="mb-3 flex items-center gap-2 text-sm"><input type="checkbox" checked={!!only} onChange={(e) => setOnly(e.target.checked ? "1" : "")} data-testid="doc-expiring-filter" /> Yalnızca süresi dolan / 60 gün içinde dolacaklar</label>
      {!rows ? <Loading /> : (
        <Table head={["Personel", "Tür", "Belge", "Geçerlilik", "Durum", ""]} testid="docs-table">
          {rows.map((d) => {
            const [label, cls] = state(d.expiry);
            return (
              <tr key={d.id}><td className="px-3 py-2 font-semibold">{d.employee_name}</td><td className="px-3 py-2">{d.type_label}</td><td className="px-3 py-2">{d.title}</td><td className="px-3 py-2">{fmtDay(d.expiry)}</td><td className={`px-3 py-2 text-xs font-semibold ${cls}`}>{label}</td>
                <td className="whitespace-nowrap px-3 py-2"><a href={`${BACKEND}/api/ops/admin/personnel-docs/${d.id}/file`} target="_blank" rel="noreferrer" className="inline-flex rounded p-1.5 hover:bg-zinc-100" data-testid={`doc-view-${d.id}`}><Eye className="h-4 w-4" /></a>
                  <button onClick={() => confirmRun("Belge pasife alınsın mı?", async () => { await api.delete(`/ops/admin/personnel-docs/${d.id}`); reload(); }, "Pasife alındı")} className="rounded p-1.5 text-red-700 hover:bg-red-50" data-testid={`doc-delete-${d.id}`}><Trash2 className="h-4 w-4" /></button></td></tr>
            );
          })}
          {!rows.length && <tr><td colSpan={6} className="p-6 text-center text-zinc-500">Belge yok.</td></tr>}
        </Table>
      )}
    </div>
  );
}
